export const ReadOnlyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="16"
    width="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.444 5.778h-1.777v-1.26a2.45 2.45 0 00-.781-1.78A2.748 2.748 0 008 2c-.707 0-1.386.265-1.886.738a2.45 2.45 0 00-.78 1.78v1.26H3.555a.916.916 0 00-.629.246.817.817 0 00-.26.593v5.877c0 .223.093.436.26.593a.916.916 0 00.629.246h8.888a.916.916 0 00.629-.246.816.816 0 00.26-.593V6.617a.817.817 0 00-.26-.593.916.916 0 00-.629-.246zM8 10.185a.695.695 0 01-.37-.106.64.64 0 01-.246-.283.597.597 0 01-.038-.363.62.62 0 01.183-.323.703.703 0 01.727-.136.66.66 0 01.298.232.605.605 0 01-.083.795.687.687 0 01-.471.184zm1.778-4.407H6.222v-1.26c0-.445.188-.872.52-1.187A1.832 1.832 0 018 2.84c.472 0 .924.176 1.257.491.333.315.52.742.52 1.188v1.259z"
      fill="var(--text-tetriary-transparent)"
    />
  </svg>
);
